import { useLingui } from "@lingui/react";
import FieldValuePair from "../FieldValuePair.tsx";
import type { SpecProps } from "./types.ts";

export const TailLift = ({ tailLift }: SpecProps<"tail_lift">) => {
  const { i18n } = useLingui();

  if (tailLift === undefined) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.tailLift",
    message: "Tail lift",
    comment: "Field for 'Tail lift' for bus and truck in ad specification",
  });

  return <FieldValuePair field={field} value={tailLift} />;
};
